import type { ZodErrorMap } from 'zod'
import { ZodIssueCode } from 'zod'

import { t } from '@/i18n'

export const zodErrorMessages: ZodErrorMap = (issue, ctx) => {
  let message: string = ctx.defaultError
  switch (issue.code) {
    case ZodIssueCode.invalid_type:
      message = t('forms.required')
      break
    case ZodIssueCode.too_small:
      if (issue.type === 'string' && issue.minimum === 1) {
        message = t('forms.not-empty')
      }
      break

    default:
      message = ctx.defaultError
  }
  return { message }
}
